import { render, staticRenderFns } from "./PlanAdmins.vue?vue&type=template&id=23b357ce&scoped=true"
import script from "./PlanAdmins.vue?vue&type=script&lang=js"
export * from "./PlanAdmins.vue?vue&type=script&lang=js"
import style0 from "./PlanAdmins.vue?vue&type=style&index=0&id=23b357ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b357ce",
  null
  
)

export default component.exports